export default class Modal {
    private selectors: NodeListOf<HTMLElement>;
    private body: HTMLElement;
    private scrollPosition: number;

    constructor(selector: string) {
        this.body = document.querySelector('body');
        this.selectors = document.querySelectorAll(selector);

        if (this.selectors) {
            this.init();
        }
    }

    private init(): void {
        this.selectors.forEach((selector: HTMLElement) => {
            selector.addEventListener('click', this.openModal.bind(this));
        });

        const closeButtons: NodeListOf<HTMLElement> = document.querySelectorAll('[data-close-modal]');
        closeButtons.forEach((button: HTMLElement) => {
            button.addEventListener('click', this.closeModal.bind(this));
        });
    }

    private openModal(e: Event): void {
        const button = e.target as HTMLElement;
        const modal: HTMLElement = document.querySelector(`[data-modal-container="${button.dataset.modal}"]`);

        if (modal) {
            this.body.classList.toggle('stop-scrolling');
            modal.classList.add('modal--active');

            this.scrollPosition = window.pageYOffset;
            this.body.style.overflow = 'hidden';
            this.body.style.position = 'fixed';
            this.body.style.top = `-${this.scrollPosition}px`;
            this.body.style.width = '100%';

            setTimeout(() => {
                modal.style.height = `${window.innerHeight}px`;
            }, 300);
        }
    }

    private closeModal(): void {
        const modal: HTMLElement = document.querySelector('.modal--active');

        if (modal) {
            modal.classList.remove('modal--active');

            this.body.style.removeProperty('overflow');
            this.body.style.removeProperty('position');
            this.body.style.removeProperty('top');
            this.body.style.removeProperty('width');
            window.scrollTo(0, this.scrollPosition);
        }
    }
}
